import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../hooks/use-http";
import DynamicPieChart from "../../../components/pieChart";
import DynamicColumnChart from "../../../components/columnChart";
import moment from "moment";
import ExpenseChart from "../../../components/Dashboard/ExpenseChart";

const ProcurementChart = (props) => {
  const frmRef = useRef({});

  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);

  const [cropwiseSalesFilter, setCropwiseSalesFilter] = useState(
    "RegionCropwiseSales"
  );
  const [cropwiseSalesReturnFilter, setcropwiseSalesReturnFilter] = useState(
    "RegionCropwiseSalesReturn"
  );
  const [productwiseSalesFilter, SetProductwiseSalesFilter] = useState(
    "RegionProductwiseSales"
  );

  const [expenseData, setExpenseData] = useState([]);
  const [cropwiseSalesData, setCropwiseSalesData] = useState([]);
  const [cropwiseSalesReturnData, setCropwiseSalesReturnData] = useState([]);
  const [productwiseSalesData, setProductwiseSalesData] = useState([]);
  const [customerwiseSalesData, setCustomerwiseSalesData] = useState([]);

  const [
    executivewiseCropSalesReturnData,
    setExecutivewiseCropSalesReturnData,
  ] = useState([]);
  const [executivewiseCropSalesData, setExecutivewiseCropSalesData] = useState(
    []
  );
  const [expenseRegionData, setExpenseRegionData] = useState([]);
  const [regionProductwiseSalesData, setRegionProductwiseSalesData] = useState(
    []
  );
  const [regionCustomerwiseSalesData, setRegionCustomerwiseSalesData] =
    useState([]);

  //  New State

  const [goodsIssueData, setGoodsIssueData] = useState([]);

  const [executivewiseGoodsIssueData, setExecutivewiseGoodsIssueData] =
    useState([]);

  const data = [
    {
      CropName: "Apple",
      CropArea: 27,
    },
    {
      CropName: "Bell Paper",
      CropArea: 25,
    },
    {
      CropName: "Pineapple",
      CropArea: 18,
    },
  ];

  const [cropwiseAreacoveredAll, setCropwiseAreacoveredAll] = useState([]);

  const [cropwiseAreacovered, setCropwiseAreacovered] = useState([]);
  const [regionCropArea, setRegionCropArea] = useState("--All--");
  const [regionCropProcurement, setRegionCropProcurement] = useState("--All--");
  const [cropwiseProcurmentAll, setCropwiseProcurmentAll] = useState([]);
  const [cropwiseProcurment, setCropwiseProcurment] = useState([]);

  const [cropwiseInvoiceDetailAll, setCropwiseInvoiceDetailAll] = useState([]);
  const [cropwiseInvoiceDetail, setCropwiseInvoiceDetail] = useState([]);

  const [cropwiseHarvestAll, setCropwiseHarvestAll] = useState([]);
  const [cropwiseHarvest, setCropwiseHarvest] = useState([]);
  const [regionCropsHarvest, setRegionCropsHarvest] = useState("--All--");

  const [cropwiseYieldEstiamtionAll, setCropwiseYieldEstiamtionAll] = useState(
    []
  );
  const [cropwiseYieldEstiamtion, setCropwiseYieldEstiamtion] = useState([]);
  const [regionCropsYieldEstiamtion, setRegionCropsYieldEstiamtion] =
    useState("--All--");

  const [
    cropwiseYieldEstiamtionVSHarvestAll,
    setCropwiseYieldEstiamtionVSHarvestAll,
  ] = useState([]);
  const [
    cropwiseYieldEstiamtionVSHarvest,
    setCropwiseYieldEstiamtionVSHarvest,
  ] = useState([]);
  const [
    regionCropsYieldEstiamtionVSHarvest,
    setRegionCropsYieldEstiamtionVSHarvest,
  ] = useState("--All--");

  const { sendRequest: getGoodsIssueData } = useHttp();

  const { sendRequest: getProductData } = useHttp();

  const fillGoodsIssueData = (employeeId, regionId) => {
    var urlfilter = "";

    urlfilter =
      urlfilter + `&fromDate=${moment(selectedFromDate).format("DD/MM/YYYY")}`;

    urlfilter =
      urlfilter + `&toDate=${moment(selectedToDate).format("DD/MM/YYYY")}`;

    if (employeeId > 0) {
      urlfilter = `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }

    var url = `/api/farmerGoodsIssuereport/?orgId=${localStorage.getItem(
      "orgId"
    )} ${urlfilter} `;

    var productMasterData = [];

    getProductData(
      {
        url: "/api/product/",
      },
      (res) => {
        if (res) {
          productMasterData = res;

          getGoodsIssueData(
            {
              url: url,
            },
            (data) => {
              //console.log("GI reportdata", data);

              var goodsIssueData = data;
              // var newList = [];
              // var i = 0;
              // do {
              //   var farmeritem = goodsIssueData[i];
              //   //  //console.log("farmeritem", farmeritem);

              //   if (farmeritem.goodsIssue.length > 0) {
              //     //  //console.log("farmeritem.goodsIssue", farmeritem.goodsIssue);
              //     var strgoodsIssue = JSON.stringify(farmeritem.goodsIssue);

              //     var goodsIssue = JSON.parse(strgoodsIssue);

              //     var j = 0;

              //     do {
              //       var goodsIssueitem = goodsIssue[j];
              //       var strproductDetails = JSON.stringify(
              //         goodsIssueitem.productDetails
              //       );
              //       var productDetails = JSON.parse(
              //         JSON.parse(strproductDetails)
              //       );
              //       //  //console.log("productDetails", productDetails);

              //       var k = 0;

              //       do {
              //         var productItem = productDetails[k];

              //         var newList = newList.concat({
              //           fieldExecutiveName: farmeritem.executiveName,
              //           regionName: farmeritem.regionName,
              //           fieldExecutiveId: farmeritem.fieldExecutiveId,
              //           regionId: farmeritem.regionId,
              //           farmerNo: farmeritem.farmerNo,
              //           farmerName: farmeritem.farmerName,
              //           goodsIssueDate: goodsIssueitem.goodsIssueDate,
              //           totalAmount: goodsIssueitem.totalAmount,
              //           discountAmount: goodsIssueitem.discountAmount,
              //           discount: goodsIssueitem.discount,
              //           productName: productItem.productName,
              //           productId: productItem.productId,
              //           Quantity: productItem.Quantity,
              //           unitAbbreviation: productItem.unitAbbreviation,
              //           amount: productItem.useAmt,
              //         });

              //         k++;
              //       } while (productDetails.length > k);

              //       j++;
              //     } while (goodsIssue.length > j);
              //   }

              //   i++;
              // } while (goodsIssueData.length > i);

              // //  //console.log("Product newList", newList);

              // var fieldExecutiveNamelist = [
              //   ...new Set(newList.map((q) => q.fieldExecutiveName)),
              // ];

              // var productIdlist = [...new Set(newList.map((q) => q.productId))];

              // i = 0;
              // var newProductList = [];
              // do {
              //   var j = 0;
              //   do {
              //     var selectedcroplist = newList.filter(
              //       (item) =>
              //         item.productId == productIdlist[j] &&
              //         item.fieldExecutiveName == fieldExecutiveNamelist[i]
              //     );

              //     var totalAmount = 0;

              //     selectedcroplist.forEach((item) => {
              //       totalAmount += parseFloat(item.amount || 0);
              //     });

              //     var productTypeName = "";
              //     var productSubTypeName = "";

              //     if (parseFloat(totalAmount) > 0) {
              //       var dataitem = selectedcroplist[0];
              //       var itemlist = productMasterData.filter(
              //         (item) => item.productId == dataitem.productId
              //       );

              //       if (itemlist.length > 0) {
              //         productTypeName = itemlist[0].productTypeName;
              //         productSubTypeName = itemlist[0].productSubTypeName;
              //       }

              //       var newProductList = newProductList.concat({
              //         fieldExecutiveName: dataitem.fieldExecutiveName,
              //         regionName: dataitem.regionName,

              //         fieldExecutiveId: dataitem.fieldExecutiveId,
              //         regionId: dataitem.regionId,

              //         productId: dataitem.productId,
              //         totalAmount: totalAmount,
              //         productTypeName: productTypeName,
              //         productSubTypeName: productSubTypeName,
              //       });
              //     }
              //     j++;
              //   } while (productIdlist.length > j);

              //   i++;
              // } while (fieldExecutiveNamelist.length > i);

              var newProductList = goodsIssueData;
              console.log("newProductList", newProductList);

              setGoodsIssueData(newProductList);
              loadGoodsIssueFilterData(newProductList, 0);
            }
          );
        }
      }
    );
  };
  useEffect(() => {
    fillGoodsIssueData(0);
  }, [getGoodsIssueData]);

  const loadGoodsIssueFilterData = (data, id) => {
    //  //console.log("data")
    if (data && data.length > 0) {
      var tempData = data;

      var productTypeNamelist = [
        ...new Set(tempData.map((q) => q.productTypeName)),
      ];
      //  //console.log('productTypeNamelist',productTypeNamelist);
      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.productTypeName == productTypeNamelist[i]
        );

        var totalAmount = 0;
        selectedcroplist.forEach((item) => {
          totalAmount += parseFloat(item.totalAmount || 0);
        });

        newcropData = newcropData.concat({
          productTypeName: productTypeNamelist[i],
          Amount: totalAmount,
        });

        i++;
      } while (productTypeNamelist.length > i);

      //  //console.log('newcropData',newcropData);
      let temp = [];
      temp.push(["groupName", "Amount"]);
      data &&
        newcropData.forEach((item) =>
          temp.push([item.productTypeName || "-", item.totalAmount])
        );

      if (temp.length == 1) {
        temp.push(["", 0]);
        temp.push(["", 0]);
      }

      console.log("setExecutivewiseGoodsIssueData", newcropData);
      setExecutivewiseGoodsIssueData(newcropData);
    }
  };

  const { sendRequest: geOverallRegionWiseExpense } = useHttp();

  const fillOverallRegionWiseExpense = (employeeId, regionId) => {
    var urlfilter = "";
    urlfilter =
      urlfilter + `&fromDate=${moment(selectedFromDate).format("DD/MM/YYYY")}`;

    urlfilter =
      urlfilter + `&toDate=${moment(selectedToDate).format("DD/MM/YYYY")}`;

    if (employeeId > 0) {
      urlfilter = `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${regionId}`;
    }

    var url = `/api/OverallRegionWiseExpenseWebChart/?orgId=${localStorage.getItem(
      "orgId"
    )} ${urlfilter} `;

    geOverallRegionWiseExpense(
      {
        url: url,
      },
      (data) => {
        //console.log("geOverallRegionWiseExpense", data);
        setExpenseData(data);
        loadExpenseFilterData(data);
      }
    );
  };
  useEffect(() => {
    fillOverallRegionWiseExpense(0, 0);
  }, [geOverallRegionWiseExpense]);

  const loadExpenseFilterData = (data) => {
    if (data && data.length > 0) {
      var tempData = data;
      //console.log("loadExpenseFilterData",tempData)

      var regionlist = [...new Set(tempData.map((q) => q.regionName))];
      //  //console.log("regionlist",regionlist)
      var i = 0;
      var newcropData = [];

      do {
        var selectedcroplist = tempData.filter(
          (item) => item.regionName == regionlist[i]
        );
        ////console.log("selectedcroplist",selectedcroplist)
        var totalExpeneAmount = 0;

        selectedcroplist.forEach((item) => {
          totalExpeneAmount += parseFloat(item.expenseAmount || 0);
        });

        newcropData = newcropData.concat({
          regionName: regionlist[i],
          totalExpeneAmount: totalExpeneAmount,
        });

        i++;
      } while (regionlist.length > i);

      //console.log("regionName tempData",newcropData)
      setExpenseRegionData(newcropData);
    }
  };

  const { sendRequest: getcropwiseAreacoveredAll } = useHttp();

  const fillallChartData = () => {
    //  //console.log("fillallChartData",fillallChartData)
    var urlfilter = "";

    urlfilter = `orgId=${localStorage.getItem("orgId")}`;

    urlfilter =
      urlfilter + `&fromDate=${moment(selectedFromDate).format("DD/MM/YYYY")}`;

    urlfilter =
      urlfilter + `&toDate=${moment(selectedToDate).format("DD/MM/YYYY")}`;

    var url = `/api/OverallCropAreaWebChart/? ${urlfilter} `;

    getcropwiseAreacoveredAll(
      {
        url: url,
      },
      (data) => {
        //console.log("getcropwiseAreacoveredAll",data)

        setCropwiseAreacoveredAll(data.cropwiseAreaCovered);
        setCropwiseProcurmentAll(data.procurementDetail);
        setCropwiseInvoiceDetailAll(data.invoiceDetail);

        // setCropwiseHarvestAll(data.cropwiseHarvest);
        // setCropwiseYieldEstiamtionAll(data.cropsYieldEstiamtion);
        // setCropwiseYieldEstiamtionVSHarvestAll(data.cropsYieldEstiamtion);

        loadcropwiseAreacovered(data.cropwiseAreaCovered, 0);
        loadProcurementDetailcovered(data.procurementDetail, 0);
        loadInvoiceDetailcovered(data.invoiceDetail, 0);
        //   loadcropwiseHarvestcovered(data.cropwiseHarvest, 0);
        //   loadcropwisecropsYieldEstiamtion(data.cropsYieldEstiamtion, 0);
        //   loadcropwisecropsYieldEstiamtionVSHarvest(data.cropsYieldEstiamtion, 0);
      }
    );
  };
  useEffect(() => {
    fillallChartData();
  }, [getcropwiseAreacoveredAll]);

  const loadcropwiseAreacovered = (data, id) => {
    //console.log("loadcropwiseAreacovered",data)

    if (data && data.length > 0) {
      var tempData = data;

      if (id != 0) {
        if (regionCropArea == "Regionwise") {
          tempData = data.filter((item) => item.regionId == id);
        } else tempData = data.filter((item) => item.fieldExecutiveId == id);
      }

      var croplist = [...new Set(tempData.map((q) => q.cropName))];

      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.cropName == croplist[i]
        );

        var totalCropArea = 0;
        selectedcroplist.forEach((item) => {
          totalCropArea += parseFloat(item.totalArea || 0);
        });

        var totalplotAreaUnit = "Ha";

        newcropData = newcropData.concat({
          CropName: croplist[i],
          CropArea: totalCropArea,
        });

        i++;
      } while (croplist.length > i);

      //console.log("cropwiseAreacovered 456",newcropData)    ;

      setCropwiseAreacovered(newcropData);
    }
  };

  const loadProcurementDetailcovered = (data, id) => {
    //console.log("loadProcurementDetailcovered",data)

    if (data && data.length > 0) {
      var tempData = data;

      if (id != 0) {
        if (regionCropArea == "Regionwise") {
          tempData = data.filter((item) => item.regionId == id);
        } else tempData = data.filter((item) => item.fieldExecutiveId == id);
      }

      var croplist = [...new Set(tempData.map((q) => q.cropName))];

      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.cropName == croplist[i]
        );

        var totalCropQty = 0;
        selectedcroplist.forEach((item) => {
          totalCropQty += parseFloat(item.totalQty || 0);
        });

        var totalplotAreaUnit = "Kg";

        newcropData = newcropData.concat({
          CropName: croplist[i],
          CropQty: totalCropQty,
        });

        i++;
      } while (croplist.length > i);

      //console.log("cropwiseProcurment 456",newcropData)    ;

      setCropwiseProcurment(newcropData);
    }
  };

  const loadInvoiceDetailcovered = (data, id) => {
    //console.log("loadInvoiceDetailcovered",data)

    if (data && data.length > 0) {
      var tempData = data;

      if (id != 0) {
        if (regionCropArea == "Regionwise") {
          tempData = data.filter((item) => item.regionId == id);
        } else tempData = data.filter((item) => item.fieldExecutiveId == id);
      }

      var croplist = [...new Set(tempData.map((q) => q.cropName))];

      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.cropName == croplist[i]
        );

        var totalAmount = 0;
        selectedcroplist.forEach((item) => {
          totalAmount += parseFloat(item.totalAmount || 0);
        });

        var totalplotAreaUnit = "Kg";

        newcropData = newcropData.concat({
          CropName: croplist[i],
          Amount: totalAmount,
        });

        i++;
      } while (croplist.length > i);

      //console.log("CropwiseInvoiceDetail 456",newcropData)    ;

      setCropwiseInvoiceDetail(newcropData);
    }
  };

  const loadcropwiseHarvestcovered = (data, id) => {
    if (data && data.length > 0) {
      var tempData = data;

      if (id != 0) {
        if (regionCropsHarvest == "Regionwise") {
          tempData = data.filter((item) => item.regionId == id);
        } else tempData = data.filter((item) => item.fieldExecutiveId == id);
      }

      var croplist = [...new Set(tempData.map((q) => q.cropName))];

      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.cropName == croplist[i]
        );

        var totalHarvestQuantity = 0;
        selectedcroplist.forEach((item) => {
          totalHarvestQuantity += parseFloat(item.HarvestQuantity || 0);
        });

        var totalplotAreaUnit = "Ha";

        newcropData = newcropData.concat({
          CropName: croplist[i],
          Quantity: totalHarvestQuantity,
        });

        i++;
      } while (croplist.length > i);

      setCropwiseHarvest(newcropData);
    }
  };

  const loadcropwisecropsYieldEstiamtion = (data, id) => {
    // //console.log("loadcropwisecropsYieldEstiamtion",id)
    if (data && data.length > 0) {
      var tempData = data;

      if (id != 0) {
        if (regionCropsYieldEstiamtion == "Regionwise") {
          tempData = data.filter((item) => item.regionId == id);
        } else tempData = data.filter((item) => item.fieldExecutiveId == id);
      }

      var croplist = [...new Set(tempData.map((q) => q.cropName))];

      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.cropName == croplist[i]
        );

        var totalHarvestQuantity = 0;
        var totalEstiamtionQuantity = 0;
        selectedcroplist.forEach((item) => {
          totalHarvestQuantity += parseFloat(item.HarvestQuantity || 0);
          totalEstiamtionQuantity += parseFloat(item.EstiamtionQuantity || 0);
        });

        var totalplotAreaUnit = "Ha";

        newcropData = newcropData.concat({
          CropName: croplist[i],
          Quantity: totalEstiamtionQuantity,
        });

        i++;
      } while (croplist.length > i);

      setCropwiseYieldEstiamtion(newcropData);
    }
  };

  const loadcropwisecropsYieldEstiamtionVSHarvest = (data, id) => {
    //  //console.log("loadcropwisecropsYieldEstiamtionVSHarvest",id)
    if (data && data.length > 0) {
      var tempData = data;

      //  //console.log("data 456",tempData)

      if (id != 0) {
        if (regionCropsYieldEstiamtionVSHarvest == "Regionwise") {
          tempData = data.filter((item) => item.regionId == id);
        } else tempData = data.filter((item) => item.fieldExecutiveId == id);
      }

      //  //console.log("data 456",tempData)
      var croplist = [...new Set(tempData.map((q) => q.cropName))];

      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.cropName == croplist[i]
        );

        var totalHarvestQuantity = 0;
        var totalEstiamtionQuantity = 0;
        selectedcroplist.forEach((item) => {
          totalHarvestQuantity += parseFloat(item.HarvestQuantity || 0);
          totalEstiamtionQuantity += parseFloat(item.EstiamtionQuantity || 0);
        });

        var totalplotAreaUnit = "Ha";

        newcropData = newcropData.concat({
          label: croplist[i],
          type: "Harvest",
          value: totalHarvestQuantity,
        });

        newcropData = newcropData.concat({
          label: croplist[i],
          type: "Estimate",
          value: totalEstiamtionQuantity,
        });

        i++;
      } while (croplist.length > i);

      //  //console.log("RegionCropsYieldEstiamtionVSHarvest 456",newcropData)    ;

      setCropwiseYieldEstiamtionVSHarvest(newcropData);
    }
  };

  // const data = [
  //   {
  //     label: "Apple.",
  //     type: "Yield",
  //     value: 2800,
  //   },
  //   {
  //     label: "Apple.",
  //     type: "Harvest",
  //     value: 2260,
  //   },
  //   {
  //     label: "Banana.",
  //     type: "Yield",
  //     value: 1800,
  //   },
  //   {
  //     label: "Banana.",
  //     type: "Harvest",
  //     value: 1300,
  //   },
  //   {
  //     label: "Tomato.",
  //     type: "Yield",
  //     value: 950,
  //   },
  //   {
  //     label: "Tomato.",
  //     type: "Harvest",
  //     value: 900,
  //   },
  //   {
  //     label: "Bell Paper.",
  //     type: "Yield",
  //     value: 500,
  //   },
  //   {
  //     label: "Bell Paper.",
  //     type: "Harvest",
  //     value: 390,
  //   },
  //   {
  //     label: "Pineapple.",
  //     type: "Yield",
  //     value: 170,
  //   },
  //   {
  //     label: "Pineapple.",
  //     type: "Harvest",
  //     value: 100,
  //   },
  // ];

  const goodsIssueDetailConfig = {
    data: executivewiseGoodsIssueData,
    xField: "productTypeName",
    yField: "Amount",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Amount",
      },
    },
    yAxis: {
      title: {
        text: "Crop",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      productTitle: {
        alias: "Quantity",
      },
      quantityBal: {
        alias: "Total Quantity",
      },
    },
  };

  const cropwiseInvoiceDetailConfig = {
    data: cropwiseInvoiceDetail,
    xField: "CropName",
    yField: "Amount",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Amount",
      },
    },
    yAxis: {
      title: {
        text: "Crop",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      productTitle: {
        alias: "Quantity",
      },
      quantityBal: {
        alias: "Total Quantity",
      },
    },
  };

  const RegionwiseExpensePieConfig = {
    appendPadding: 10,
    data: expenseRegionData,
    angleField: "totalExpeneAmount",
    colorField: "regionName",
    radius: 0.75,
    label: {
      type: "spider",
      labelHeight: 28,
      content: "{name}\n{percentage}",
    },
    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
    ],
  };

  const CropwiseProcurmentPieConfig = {
    appendPadding: 10,
    data: cropwiseProcurment,
    angleField: "CropQty",
    colorField: "CropName",
    radius: 0.75,
    label: {
      type: "spider",
      labelHeight: 28,
      content: "{name}\n{percentage}",
    },
    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
    ],
  };

  const CropwiseAreaPieConfig = {
    appendPadding: 10,
    data: cropwiseAreacovered,
    angleField: "CropArea",
    colorField: "CropName",
    radius: 0.75,
    label: {
      type: "spider",
      labelHeight: 28,
      content: "{name}\n{percentage}",
    },
    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
    ],
  };

  const configbar2 = {
    data: cropwiseYieldEstiamtionVSHarvest,
    isGroup: true,
    xField: "label",
    yField: "value",
    seriesField: "type",

    label: {
      position: "top",

      layout: [
        {
          type: "interval-adjust-position",
        },
        {
          type: "interval-hide-overlap",
        },
        {
          type: "adjust-color",
        },
      ],
    },
    scrollbar: {
      type: "horizontal",
    },
  };

  const YieldEstiamtionconfig = {
    data: cropwiseYieldEstiamtion,
    xField: "CropName",
    yField: "Quantity",
    label: {
      position: "middle",

      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        // autoHide: true,
        autoRotate: false,
        rotate: 220,
      },
      title: {
        text: "Quantity",
      },
    },
    yAxis: {
      title: {
        text: "Crop",
      },
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      productTitle: {
        alias: "Quantity",
      },
      quantityBal: {
        alias: "Total Quantity",
      },
    },
  };

  const { sendRequest: getWarehouseData } = useHttp();

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 90);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate",toDate)

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
      }
    );
  }, [getEmp]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/region/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //  //console.log("region", data);

        setRegionData(data);
      }
    );
  }, [getRegion]);

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <h2>Procurement Dashboard</h2>
            </div>
            <div className="row"></div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    // ref={(el) => (frmRef.current["pdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"to_date"}>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    // ref={(el) => (frmRef.current["pdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Cropwise Area</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["emp_id"] = el)}
                          value={regionCropArea}
                          onChange={(e) => {
                            setRegionCropArea(e.target.value);
                            loadcropwiseAreacovered(cropwiseAreacoveredAll, 0);
                          }}
                        >
                          <option>--All--</option>
                          <option value="Regionwise">Regionwise</option>
                          <option value="Executivewise">Executivewise</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        {regionCropArea == "Regionwise" ? (
                          <select
                            id="regionId"
                            className="form-control"
                            ref={(el) => (frmRef.current["regionId"] = el)}
                            value={regionId}
                            onChange={(e) => {
                              var id = 0;
                              if (e.target.value != "--Select Region--") {
                                id = e.target.value;
                              }
                              loadcropwiseAreacovered(
                                cropwiseAreacoveredAll,
                                id
                              );
                            }}
                          >
                            <option>--Select Region--</option>
                            {regionData &&
                              regionData.map((x) => (
                                <option
                                  key={x.regionId}
                                  user-id={x.regionId}
                                  value={x.regionId}
                                >
                                  {x.regionName}
                                </option>
                              ))}
                          </select>
                        ) : (
                          <select
                            id="emp_id"
                            className="form-control"
                            ref={(el) => (frmRef.current["emp_id"] = el)}
                            value={employeeId}
                            onChange={(e) => {
                              var id = 0;
                              if (e.target.value != "--Select Executive--") {
                                id = e.target.value;
                              }
                              loadcropwiseAreacovered(
                                cropwiseAreacoveredAll,
                                id
                              );
                            }}
                          >
                            <option>--Select Executive--</option>
                            {employeeData &&
                              employeeData.map((x) => (
                                <option
                                  key={x.userId}
                                  user-id={x.userId}
                                  value={x.userId}
                                >
                                  {x.employeeName}
                                </option>
                              ))}
                          </select>
                        )}
                      </div>
                    </div>
                    <div>&nbsp;</div>

                    <div style={{ width: "80%" }}>
                      &nbsp; {/* <Pie {...CropwiseAreaPieConfig} /> */}
                      <DynamicPieChart
                        data={cropwiseAreacovered}
                        angleField="CropArea"
                        colorField="CropName"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Cropwise Procurement</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["emp_id"] = el)}
                          value={regionCropProcurement}
                          onChange={(e) => {
                            setRegionCropProcurement(e.target.value);
                            loadProcurementDetailcovered(
                              cropwiseProcurmentAll,
                              0
                            );
                          }}
                        >
                          <option>--All--</option>
                          <option value="Regionwise">Regionwise</option>
                          <option value="Executivewise">Executivewise</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        {regionCropProcurement == "Regionwise" ? (
                          <select
                            id="regionId"
                            className="form-control"
                            ref={(el) => (frmRef.current["regionId"] = el)}
                            value={regionId}
                            onChange={(e) => {
                              var id = 0;
                              if (e.target.value != "--Select Region--") {
                                id = e.target.value;
                              }
                              loadProcurementDetailcovered(
                                cropwiseProcurmentAll,
                                id
                              );
                            }}
                          >
                            <option>--Select Region--</option>
                            {regionData &&
                              regionData.map((x) => (
                                <option
                                  key={x.regionId}
                                  user-id={x.regionId}
                                  value={x.regionId}
                                >
                                  {x.regionName}
                                </option>
                              ))}
                          </select>
                        ) : (
                          <select
                            id="emp_id"
                            className="form-control"
                            ref={(el) => (frmRef.current["emp_id"] = el)}
                            value={employeeId}
                            onChange={(e) => {
                              var id = 0;
                              if (e.target.value != "--Select Executive--") {
                                id = e.target.value;
                              }
                              loadProcurementDetailcovered(
                                cropwiseProcurmentAll,
                                id
                              );
                            }}
                          >
                            <option>--Select Executive--</option>
                            {employeeData &&
                              employeeData.map((x) => (
                                <option
                                  key={x.userId}
                                  user-id={x.userId}
                                  value={x.userId}
                                >
                                  {x.employeeName}
                                </option>
                              ))}
                          </select>
                        )}
                      </div>
                    </div>
                    <div>&nbsp;</div>

                    <div style={{ width: "80%" }}>
                      &nbsp; {/* <Pie {...CropwiseProcurmentPieConfig} /> */}
                      <DynamicPieChart
                        data={cropwiseProcurment}
                        angleField="CropQty"
                        colorField="CropName"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Cropwise Payment </h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    <div>&nbsp;</div>

                    <div style={{ width: "80%" }}>
                      {/* &nbsp; <Column {...cropwiseInvoiceDetailConfig} /> */}
                      <DynamicColumnChart
                        data={cropwiseInvoiceDetail}
                        xField="CropName"
                        yField="Amount"
                        xAxisTitle="Amount"
                        yAxisTitle="Crop"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Expenses</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    <div style={{ width: "80%" }}>
                      {/* <Pie {...RegionwiseExpensePieConfig} /> */}
                      <DynamicPieChart
                        data={expenseRegionData}
                        angleField="totalExpeneAmount"
                        colorField="regionName"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card card-primary shadow">
                  <div className="card-header">
                    <h3 className="card-title">Goods Issue</h3>

                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="maximize"
                      >
                        <i className="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>

                  <div className="card-body">
                    <div>&nbsp;</div>

                    <div style={{ width: "80%" }}>
                      {/* <Column {...goodsIssueDetailConfig} /> */}
                      <DynamicColumnChart
                        data={executivewiseGoodsIssueData}
                        xField="productTypeName"
                        yField="Amount"
                        xAxisTitle="Amount"
                        yAxisTitle="Crop"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ProcurementChart;
